import _os2 from "os";
import _signals2 from "./signals.js";
import _realtime2 from "./realtime.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signalsByNumber = exports.signalsByName = void 0;
var _os = _os2;
var _signals = _signals2;
var _realtime = _realtime2;

const getSignalsByName = function () {
  const signals = (0, _signals.getSignals)();
  return signals.reduce(getSignalByName, {});
};

const getSignalByName = function (signalByNameMemo, {
  name,
  number,
  description,
  supported,
  action,
  forced,
  standard
}) {
  return { ...signalByNameMemo,
    [name]: {
      name,
      number,
      description,
      supported,
      action,
      forced,
      standard
    }
  };
};

const signalsByName = getSignalsByName();
exports.signalsByName = signalsByName;

const getSignalsByNumber = function () {
  const signals = (0, _signals.getSignals)();
  const length = _realtime.SIGRTMAX + 1;
  const signalsA = Array.from({
    length
  }, (value, number) => getSignalByNumber(number, signals));
  return Object.assign({}, ...signalsA);
};

const getSignalByNumber = function (number, signals) {
  const signal = findSignalByNumber(number, signals);

  if (signal === undefined) {
    return {};
  }

  const {
    name,
    description,
    supported,
    action,
    forced,
    standard
  } = signal;
  return {
    [number]: {
      name,
      number,
      description,
      supported,
      action,
      forced,
      standard
    }
  };
};

const findSignalByNumber = function (number, signals) {
  const signal = signals.find(({
    name
  }) => _os.constants.signals[name] === number);

  if (signal !== undefined) {
    return signal;
  }

  return signals.find(signalA => signalA.number === number);
};

const signalsByNumber = getSignalsByNumber();
exports.signalsByNumber = signalsByNumber; //# sourceMappingURL=main.js.map

export default exports;
export const __esModule = exports.__esModule;
const _signalsByNumber = exports.signalsByNumber,
      _signalsByName = exports.signalsByName;
export { _signalsByNumber as signalsByNumber, _signalsByName as signalsByName };